import { Diagnostic, Rule } from "@siteimprove/alfa-act";
import { DOM } from "@siteimprove/alfa-aria";
import { Cache } from "@siteimprove/alfa-cache";
import { Element, Namespace, Query } from "@siteimprove/alfa-dom";
import { Map } from "@siteimprove/alfa-map";
import { Predicate } from "@siteimprove/alfa-predicate";
import { Err, Ok } from "@siteimprove/alfa-result";
import { Criterion, Technique } from "@siteimprove/alfa-wcag";
import { expectation } from "../common/act/expectation.js";
import { Scope, Stability } from "../tags/index.js";
const { hasRole, isPerceivableForAll } = DOM;
const { hasAttribute, hasId, hasName, hasNamespace } = Element;
const { and, equals } = Predicate;
const { getElementDescendants } = Query;
export default Rule.Atomic.of({
    uri: "https://alfa.siteimprove.com/rules/sia-r45",
    requirements: [Criterion.of("1.3.1"), Technique.of("H43")],
    tags: [Scope.Component, Stability.Stable],
    evaluate({ device, document }) {
        const cellsCache = Cache.empty();
        const headers = getElementDescendants(document)
            .filter(and(hasNamespace(Namespace.HTML), hasName("table"), isPerceivableForAll(device), hasRole(device, (role) => role.is("table"))))
            .reduce((headers, table) => {
            const cells = cellsCache
                .get(table, () => getElementDescendants(table).filter(and(hasNamespace(Namespace.HTML), hasName("td", "th"))))
                .filter(hasAttribute("headers"));
            for (const cell of cells) {
                // The previous filter ensures that headers exists.
                headers = headers.set(cell.attribute("headers").getUnsafe(), table);
            }
            return headers;
        }, Map.empty());
        return {
            applicability() {
                return headers.keys();
            },
            expectations(target) {
                // targets are headers' key, so there is something in the map.
                const table = headers.get(target).getUnsafe();
                const ids = target.tokens();
                const cells = cellsCache
                    .get(table, () => getElementDescendants(table).filter(and(hasNamespace(Namespace.HTML), hasName("td", "th"))))
                    .filter(hasId(equals(...ids)));
                return {
                    1: expectation(
                    // Each token refers to a different cell in the same table if the
                    // number of identified cells is equal to the number of IDs.
                    cells.size === ids.size, () => Outcomes.HeadersRefersToCellInTable, () => Outcomes.HeadersDoesNotReferToCellsInTable),
                    2: expectation(cells.every((cell) => !target.owner.some(equals(cell))), () => Outcomes.HeadersDoesNotRefersToSelf, () => Outcomes.HeadersRefersToSelf),
                };
            },
        };
    },
});
/**
 * @public
 */
export var Outcomes;
(function (Outcomes) {
    Outcomes.HeadersRefersToCellInTable = Ok.of(Diagnostic.of(`The \`headers\` attribute refers to cells in the same \`<table>\``));
    Outcomes.HeadersDoesNotReferToCellsInTable = Err.of(Diagnostic.of(`The \`headers\` attribute refers to cells not present in the same \`<table>\``));
    Outcomes.HeadersDoesNotRefersToSelf = Ok.of(Diagnostic.of(`The \`headers\` attribute does not refer to the cell defining it`));
    Outcomes.HeadersRefersToSelf = Err.of(Diagnostic.of(`The \`headers\` attribute refers to the cell defining it`));
})(Outcomes || (Outcomes = {}));
//# sourceMappingURL=rule.js.map